export const UPDATE_USER = 'UPDATE_USER';

export const updateUser = userInformations => ({
  type: UPDATE_USER,
  payload: userInformations
});

export const ADD_COLLABORATOR = 'ADD_COLLABORATOR';
export const addCollaborator = collaboratorInformations => ({
  type: ADD_COLLABORATOR,
  payload: collaboratorInformations
});

export const CREATE_ADDRESS = 'CREATE_ADDRESS';
export const CREATE_ADDRESS_SUCCESS = 'CREATE_ADDRESS_SUCCESS';
export const CREATE_ADDRESS_FAILURE = 'CREATE_ADDRESS_FAILURE';
export const createAddress = address => ({
  type: CREATE_ADDRESS,
  payload: address
});

export const GET_ADDRESS = 'GET_ADDRESS';
export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_FAILURE = 'GET_ADDRESS_FAILURE';
export const getAddress = () => ({
  type: GET_ADDRESS
});

export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE';
export const deleteAddress = addressId => ({
  type: DELETE_ADDRESS,
  payload: addressId
});
